import { generatePathResourceDetail, appRoutes } from '../../app/routing/routes.config.js';
import { generatePath } from '@fabric-app/utils/url/routing';

const getResourcePath = (variables) => {
  switch (variables.type) {
    case "folder":
      return generatePath(appRoutes.folder.detail, {
        folderId: variables.resourceId
      });
    case "space":
      return generatePath(appRoutes.space.detail, {
        spaceId: variables.resourceId
      });
    default:
      return generatePathResourceDetail(variables.resourceId, {
        view: "home"
      });
  }
};
const getResourcePathFromResourceDetail = (resource) => {
  return getResourcePath({
    resourceId: resource.id,
    type: resource.kind === "folder" ? resource.root?.id === resource.id ? "space" : "folder" : "resource"
  });
};

export { getResourcePath, getResourcePathFromResourceDetail };
//# sourceMappingURL=useRedirectFromShareToken.js.map
